import Instagram from './Instagram'

export default Instagram
// eslint-disable-next-line import/export
export * from './Instagram'
